/**
 * TipoRelatorioCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {TipoRelatorio} from '@/model/resource/TipoRelatorio'

/* TODO: review generated class */
@HttpExclude()
export class TipoRelatorioCollection extends PageCollection<TipoRelatorio> {
  constructor() {
    super(TipoRelatorio)
  }

  queryAsPage() {
    return this.listTipoRelatorio()
  }

  async listTipoRelatorio() {
    return await Request.get(`/admin/tipo-relatorio`, {params: this.params})
      .name('listTipoRelatorio')
      .as(this)
      .getResponse()
  }

  async listCsvTipoRelatorio() {
    return await Request.get(`/admin/tipo-relatorio/csv`, {params: this.params})
      .name('listCsvTipoRelatorio')
      .as(this)
      .getResponse()
  }
}
